<template>
  <div class="sports_item_detail">
    <Empty description="加载中..." v-if="itemDetail == ''" />
    <div class="body" v-else>
      <mVideo
        :videoUrl="itemDetail.mediaurl"
        v-if="itemDetail.mediaurl"
        height="4rem"
        fit="contain"
      ></mVideo>
      <VanImage :src="itemDetail.icon" style="width: 7.5rem;height:3.15rem;" v-else></VanImage>
      <Panel class="header" :title="itemDetail.title">
        <CellGroup :border="false">
          <Cell title="开始时间" icon="clock-o">
            {{
            itemDetail.start_time
            }}
          </Cell>
          <Cell title="截止时间" icon="clock-o">{{ itemDetail.end_time }}</Cell>
          <Cell
            title="投票开始时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_start_time && item_sub_id!=4923 && item_sub_id!=4924 && item_sub_id!=4934 && item_sub_id!=4935 && item_sub_id!=4996 && item_sub_id!=4997 && item_sub_id!=6381 && item_sub_id!=6382 && item_sub_id!=6383"
            icon="clock-o"
          >{{ itemDetail.vote_start_time }}</Cell>
          <Cell
            title="投票截止时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_end_time && item_sub_id!=4923 && item_sub_id!=4924 && item_sub_id!=4934 && item_sub_id!=4935 && item_sub_id!=4996 && item_sub_id!=4997 && item_sub_id!=6381 && item_sub_id!=6382 && item_sub_id!=6383"
            icon="clock-o"
          >{{ itemDetail.vote_end_time }}</Cell>
          <Cell title="联系方式" icon="contact" v-if="itemDetail.contact && itemDetail.contact!=0 && item_sub_id!=4923 && item_sub_id!=4924 && item_sub_id!=4934 && item_sub_id!=4935 && item_sub_id!=4996 && item_sub_id!=4997 && item_sub_id!=6381 && item_sub_id!=6382 && item_sub_id!=6383">
            {{
            itemDetail.contact
            }}
          </Cell>
          <Cell
            title="活动规程"
            icon="todo-list-o"
            is-link
            v-if="itemDetail.rules"
            @click="show = true"
          ></Cell>
        </CellGroup>
      </Panel>

      <div class="float" v-if="(itemDetail.add_draw>0 || itemDetail.activity_id) && sports_id != 10020">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220830/1661862318/368107.png" @click="godraw" alt="" >
      </div>

      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="itemDetail.rules"></div>
      </Popup>

      <Panel title="要点" v-if="itemDetail.type != 4">
        <div
          v-html="itemDetail.content"
          :class="[isshow ? 'vhtml mt' : 'vhtml']"
          style="font-size: 14px;padding:.2rem .3rem .2rem;"
        ></div>
				<div class="myArrow" v-if="isshow" @click="lookMore">
					<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220623/1655975535-62b42e6f8a501.png"/>
					<span>展示更多</span>
				</div>
				<div class="myArrow" v-if="isshow == false" @click="lookMore2">
					<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220623/1655976039-62b430673376c.png"/>
					<span>收起</span>
				</div>
      </Panel>

      <rank-list v-if="itemDetail.type == 4 && sports_id != 15 && sports_id != 30" :item_sub_id="item_sub_id" :sports_id="sports_id"></rank-list>
      <bkrank-list v-if="itemDetail.type == 4 && sports_id == 30 " :item_sub_id="item_sub_id" :sports_id="sports_id"></bkrank-list>
      <CellGroup v-if="itemDetail.type != 4 && +itemDetail.count>0 && +sports_id && item_sub_id != 4763 && sports_id != 10029" title="排行榜">
        <Cell is-link center title-class="join-list-title" @click="goRank">
          <div slot="title">
            {{ itemDetail.count }}
            <!-- <span style="font-size:12px;">人</span> -->
          </div>
          <div slot="label">已完成</div>
          <div v-if="joinList.length" class="joinuser">
            <van-image
              :src="item.avatarurl"
              v-for="(item, index) in joinList.slice(0, 5)"
              :key="index"
              :style="
                `transform:translateX(${(joinList.slice(0, 5).length -
                  1 -
                  index) *
                  25}%)`
              "
              :data-index="index"
            />
          </div>
        </Cell>
      </CellGroup>
    </div>
    <Footbar v-if="item_sub_id != 2623">
      <Cell slot="footbar" v-if="itemDetail && itemDetail.register_type == 1">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          type="primary"
          block
          :disabled="itemDetail.disabled"
          :color="buttonColor"
          @click="godetail"
        >{{ itemDetail.tips }}</Button>
        <Button
          v-else
          round
          type="primary"
          block
          :color="buttonColor"
          :to="{ name: 'sportsResult', params: this.$route.params }"
        >参赛详情</Button>
      </Cell>

      <Cell slot="footbar" v-else>
        <Button
          v-if="itemDetail.register_type == 2"
          round
          type="primary"
          block
          :color="buttonColor"
          :url="itemDetail.register_type_value"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 3"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="openImg(itemDetail.register_type_value)"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 6"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="jumpwx(itemDetail.register_type_value)"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 4"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="jumpMp(itemDetail.register_type_value)"
        >立即参与</Button>
      </Cell>
    </Footbar>
    <van-dialog v-if="itemDetail.register_type == 3" v-model="show" title="长按跳转">
      <div class="img-area">
        <img :src="itemDetail.register_type_value" />
      </div>
    </van-dialog>
    <van-action-sheet v-model="acshow" :actions="actions" @select="onSelect" cancel-text="取消" close-on-click-action />
  </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import rankList from "./rank";
import bkrankList from "./bkrank";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup,ActionSheet } from "vant";
import "./index.less";
import imgurl from "@/assets/img/common/default.png";
import { Base64 } from "js-base64";
import { mapGetters, mapMutations } from "vuex";

const normalizeLabel = (label) => {
  if (!label) return '';
  return label.replace(/\s+/g, '')
              .replace(/[:：]/g, '')
              .replace(/号码/g, '')
              .replace(/您的/g, '')
              .replace(/联系/g, '')
              .replace(/（用于领奖）/g, '')
              .replace(/\(用于领奖\)/g, '');
};

export default {
  computed: {
    ...mapGetters(["getOnlyUserInfo"]),
    imgurl() {
      return imgurl;
    },
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
  },
  components: {
    mVideo,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    Footbar,
    VanImage: Image,
    rankList,
    Popup,
    bkrankList,
    vanActionSheet: ActionSheet
  },
  props: ["item_sub_id", "sports_id"],
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
      acshow: false,
      actions: [{ name: '个人组',signtype: 1 }, { name: '团队组',signtype: 2 }],			
			isshow: true,
    };
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
		lookMore(){
			this.isshow = false
		},
		lookMore2(){
			this.isshow = true
		},
    goRank() {
      // :to=""
      if (+this.sports_id == 38){
        this.$router.push({ name: "rankResult", params: this.$route.params });      
        return
      }
      if (this.itemDetail.rank_type == 3) {
        this.$router.push({ name: "sportsGroupRank", params: this.$route.params });
        return
      }
      if (+this.itemDetail.type === 5) {
        wx.miniProgram.navigateTo({
          url: `/pages/rank/steps/index?activity_id=${this.item_sub_id}`,
        });
      } else {
        this.$router.push({ name: "sportsRank", params: this.$route.params, query: {rank_type: this.itemDetail.rank_type} });
      }
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.acshow = false;
      this.$router.push({name: 'joinSports', params: {item_sub_id: this.item_sub_id,sports_id:this.sports_id,signtype:item.signtype} })
    },
    checkNeedRegisterForm() {
      const detail = this.detail;
      const itemDetail = this.itemDetail;
      if (!detail || !itemDetail) return { needForm: true, hiddenFields: [] };

      const register_mode = detail.register_mode;
      const is_registered = detail.is_registered;
      const registered_info = detail.registered_info;

      if (register_mode == 2 && is_registered && registered_info) {
        const valueMap = {};
        const labelMap = {};

        if (registered_info.name) {
          valueMap['name'] = registered_info.name;
          valueMap['mv_name'] = registered_info.name;
          labelMap[normalizeLabel('姓名')] = registered_info.name;
        }
        if (registered_info.mobile) {
          valueMap['mobile'] = registered_info.mobile;
          valueMap['mv_mobile'] = registered_info.mobile;
          labelMap[normalizeLabel('手机')] = registered_info.mobile;
        }
        if (registered_info.register_type) {
          valueMap['register_type'] = registered_info.register_type;
          labelMap[normalizeLabel('组别')] = registered_info.register_type;
        }

        if (registered_info.registerinfos) {
          try {
            const mainRegFields = JSON.parse(registered_info.registerinfos);
            if (Array.isArray(mainRegFields)) {
              mainRegFields.forEach(field => {
                if (field.key_name && field.value !== undefined && field.value !== null && field.value !== '') {
                  valueMap[field.key_name] = field.value;
                }
                if (field.show_name && field.value !== undefined && field.value !== null && field.value !== '') {
                  labelMap[normalizeLabel(field.show_name)] = field.value;
                }
              });
            }
          } catch (e) {
            console.warn("Failed to parse main registerinfos:", e);
          }
        }

        let regForm = [];
        let hiddenFields = [];
        if (itemDetail.registerform) {
          try {
            regForm = typeof itemDetail.registerform === 'string' ? JSON.parse(itemDetail.registerform) : itemDetail.registerform;
            if (Array.isArray(regForm)) {
              const hasGroups = regForm.length > 0 && regForm[0].attrs;
              if (hasGroups) {
                regForm.forEach(group => {
                  if (group.attrs) {
                    let visibleAttrs = [];
                    group.attrs.forEach(attr => {
                      let matchedValue = valueMap[attr.key_name];
                      if (matchedValue === undefined) {
                        const norm = normalizeLabel(attr.show_name);
                        matchedValue = labelMap[norm];
                      }
                      if (matchedValue === undefined) {
                        if (['name', 'mv_name'].includes(attr.key_name)) matchedValue = valueMap['name'];
                        else if (['mobile', 'mv_mobile'].includes(attr.key_name)) matchedValue = valueMap['mobile'];
                        else if (['register_type'].includes(attr.key_name)) matchedValue = valueMap['register_type'];
                      }

                      if (matchedValue !== undefined && matchedValue !== null && matchedValue !== '') {
                        attr.value = matchedValue;
                        hiddenFields.push(attr);
                      } else {
                        visibleAttrs.push(attr);
                      }
                    });
                    group.attrs = visibleAttrs;
                  }
                });
                regForm = regForm.filter(group => group.attrs && group.attrs.length > 0);
              } else {
                let visibleAttrs = [];
                regForm.forEach(attr => {
                  let matchedValue = valueMap[attr.key_name];
                  if (matchedValue === undefined) {
                    const norm = normalizeLabel(attr.show_name);
                    matchedValue = labelMap[norm];
                  }
                  if (matchedValue === undefined) {
                    if (['name', 'mv_name'].includes(attr.key_name)) matchedValue = valueMap['name'];
                    else if (['mobile', 'mv_mobile'].includes(attr.key_name)) matchedValue = valueMap['mobile'];
                    else if (['register_type'].includes(attr.key_name)) matchedValue = valueMap['register_type'];
                  }

                  if (matchedValue !== undefined && matchedValue !== null && matchedValue !== '') {
                    attr.value = matchedValue;
                    hiddenFields.push(attr);
                  } else {
                    visibleAttrs.push(attr);
                  }
                });
                regForm = visibleAttrs;
              }
            }
          } catch (e) {
            console.log(e);
          }
        }

        if (!Array.isArray(regForm) || regForm.length === 0) {
          return { needForm: false, hiddenFields };
        }
      }

      return { needForm: true, hiddenFields: [] };
    },
    godetail() {
      if (this.detail && this.detail.register_mode == 2) {
        if (!this.detail.is_registered) {
          this.$dialog.alert({
            title: '提示',
            message: '请先在运动会主页进行报名！'
          }).then(() => {
            this.$router.replace({ name: 'jd_index4', params: { sports_id: this.sports_id } });
          });
          return;
        }

        const { needForm, hiddenFields } = this.checkNeedRegisterForm();
        if (!needForm) {
          this.$toast.loading({
            message: "正在报名...",
            duration: 0,
            forbidClick: true
          });
          this.$api.sports.submitCompare({ cpgid: this.item_sub_id, registerInfo: hiddenFields }).then((resSub) => {
            this.$toast.clear();
            if (+resSub.status === 200) {
              if (this.item_sub_id == 2591 || this.item_sub_id == 2592 || this.item_sub_id == 2593 || this.item_sub_id == 2594 || this.item_sub_id == 2595) {
                this.$router.replace({ name: 'sportsQues', params: { acid: 972 } });
              } else if (+this.itemDetail.type === 5) {
                this.$router.replace({ name: 'sportsQues', params: { acid: this.itemDetail.activity_id } });
              } else {
                this.$router.replace({ name: 'sportsResult', params: this.$route.params });
              }
            } else {
              this.$toast.fail(resSub.message || "报名失败");
            }
          }).catch(err => {
            this.$toast.clear();
            this.$toast.fail("请求失败，请稍后重试");
          });
          return;
        }

        let signtype = 1;
        this.$router.push({
          name: 'joinSports',
          params: {
            item_sub_id: this.item_sub_id,
            sports_id: this.sports_id,
            signtype: signtype
          }
        });
      } else {
        if(this.itemDetail.signtype == 3) {
          this.acshow = true;
        } else {
          this.$router.push({name: 'joinSports', params: {item_sub_id: this.item_sub_id,sports_id:this.sports_id,signtype:this.itemDetail.signtype} })
        }
      }
    },
    jumpwx(value) {
      wx.miniProgram.navigateTo({
        url: value,
      });
    },
    jumpMp(value) {
      let jump = {
        appId: value
      }
      value = Base64.encodeURI(JSON.stringify(jump));
      //跳转小程序 webview无法直接跳转外部小程序 需要通过当前小程序中转
      wx.miniProgram.navigateTo({
        url: `/pages/jumpmp/index?jumpinfo=${value}`,
      });
    },
    godraw() {
      this.$router.push({name:'luckdraw',params: {acid:this.itemDetail.add_draw>0?this.itemDetail.add_draw:this.itemDetail.activity_id}})
    },
    openImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      Promise.all([
        this.$api.sports.sportsMain(this.sports_id),
        this.$api.sports.getComparegame(params),
      ]).then(
        (res) => {
          let { bgstyle, id, tabstyle, introstyle, title, register_mode, is_registered, registered_info } = res[0].data;
          try {
            bgstyle = JSON.parse(bgstyle);
            tabstyle = JSON.parse(tabstyle);
            introstyle = JSON.parse(introstyle);
          } catch (e) {
            console.error(e);
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title, register_mode, is_registered, registered_info };
          this.joinList = Object.assign([], res[1]["data"]["list"]);
          delete res[1]["data"]["list"];
          let { start_time, end_time, sex_limit, age_limit,type } = res[1]["data"];
          start_time = moment(start_time).valueOf();
          end_time = moment(end_time).valueOf();
          var sys_time = res[1]["sys_time"] * 1000;
          let tips,
            disabled = true;
          if (sys_time < start_time) {
            tips = "活动未开始";
          } else if (sys_time > end_time) {
            if(type==4) {
              tips = "上传已结束";
            } else {
              tips = "活动已结束";
            }            
          } else {
            tips = "立即参与";
            disabled = false;
          }
          this.itemDetail = Object.assign(res[1]["data"], { tips, disabled });
          this.$toast.clear();
          //判断 是否需要 限制性别 或生日 如果需要则要填写信息
          if (+sex_limit !== 0 || +age_limit !== 0) {
            let { name, phone, id_number, gid } = this.getOnlyUserInfo;

            console.log(name);
            console.log(phone);
            console.log(id_number);
            if(gid == 605) {
              return;
            }

            if (!!name && !!phone && !!id_number) {
            } else {
              //需要补全信息
              this.toggleShowFill(true);
              return;
            }
          }
        },
        () => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.init();
    this.cf.wxShareConf();
  },
};
</script>

<style scoped>
.html >>> img {
  max-width: 100%;
}

.img-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-area img {
  max-width: 100%;
}
</style>
